<mat-card class="welcome-card">
    <mat-card-header class="d-flex justify-content-center animate-slide-up delay-1">
        <img src="/assets/icons/avyna/logo.svg" alt="Avyna Logo" class="avyna-logo pb-3" />
    </mat-card-header>

    <mat-card-content class="text-center">
        <div class="mb-4">
            <h1 class="fs-2 fw-bold title-text mb-3 animate-slide-up delay-2">
                {{ 'app.auth.login.title' | translate }}
            </h1>

            <p class="fs-6 subtitle-text animate-slide-up delay-2">
                {{ 'app.auth.login.subtitle' | translate }}<br />
                {{ 'app.auth.login.subtitle_line2' | translate }}
            </p>
        </div>

        <button mat-flat-button class="w-100 microsoft-btn animate-slide-up delay-3" (click)="loginWithMicrosoft()"
            [disabled]="isLoading()">
            @if (isLoading()) {
            <mat-spinner diameter="20" color="accent" class="d-inline-block me-2"></mat-spinner>
            <span>{{ 'app.auth.login.connecting' | translate }}</span>
            } @else {
            <img src="/assets/icons/microsoft_icon.svg" alt="Microsoft" class="d-inline-block me-2 microsoft-icon" />
            <span>{{ 'app.auth.login.sign_in_microsoft' | translate }}</span>
            }
        </button>

        <div
            class="d-flex align-items-center justify-content-center security-hint small gap-2 pt-3 animate-slide-up delay-4">
            <mat-icon>security</mat-icon>
            <span>{{ 'app.auth.login.security_hint' | translate }}</span>
        </div>
    </mat-card-content>
</mat-card>